export class FacebookTracker
{
    track(type, params)
    {
        if(isDevelopment) {
            //console.log('track', type, params);
        } else if (typeof params === 'object') {
            window.fbq('track', type, params);
        } else {
            window.fbq('track', type);
        }
    }

    viewContent(params)
    {
        this.track('ViewContent', params);
    }

    viewContentProduct(product)
    {
        this.viewContent({
            value: product.price,
            currency: product.currency || 'RUB',
            content_ids: product.parent_id,
            content_type: 'product'
        });
    }

    viewContentCategory(category)
    {
        this.viewContent({
            content_ids: category.id,
            content_type: 'product_group'
        });
    }

    search()
    {
        this.track('Search');
    }

    addToCart(product)
    {
        this.track('AddToCart', {
            value: product.price,
            currency: product.currency,
            content_ids: product.parent_id,
            content_type: 'product'
        });
    }

    addToWishlist()
    {
        this.track('AddToWishlist');
    }

    addReview()
    {
        this.track('AddReview');
    }

    addQuestion()
    {
        this.track('AddQuestion');
    }

    productNotificationAdd()
    {
        this.track('ProductNotificationAdd');
    }

    initiateCheckout()
    {
        this.track('InitiateCheckout');
    }

    addPaymentInfo()
    {
        this.track('AddPaymentInfo');
    }

    purchase(orderInfo)
    {
        let products = [];
        let productsIds = [];

        orderInfo.order_items.forEach(function(item, i, arr) {
            products.push({
                'id': item.id,
                'quantity': item.quantity
            });
            productsIds.push(item.id);
        });

        this.track('Purchase', {
            'value' : orderInfo.price,
            'currency': orderInfo.currency,
            'contents': products,
            'content_ids': productsIds,
            'content_type': 'product',
        });
    }

    lead(params)
    {
        this.track('Lead', params);
    }

    leadOrder(orderInfo)
    {
        let products = [];
        let productsIds = [];

        orderInfo.order_items.forEach(function(item, i, arr) {
            products.push({
                'id': item.id,
                'quantity': item.quantity
            });
            productsIds.push(item.id);
        });

        this.lead({
            'value' : orderInfo.price,
            'currency': orderInfo.currency,
            'contents': products,
            'content_ids': productsIds,
            'content_type': 'product',
        });
    }

    completeRegistration()
    {
        this.track('CompleteRegistration');
    }

    newsletterSubscription()
    {
        this.track('NewsletterSubscription');
    }

    selectedShop()
    {
        this.track('SelectedShop');
    }

    requestCallBack()
    {
        this.track('RequestCallBack');
    }

    applyingFilter()
    {
        this.track('ApplyingFilter');
    }

    buyOneClick()
    {
        this.track('BuyOneClick');
    }

    clickSocialNetwork()
    {
        this.track('SocialNetwork');
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/facebook.js